export default __webpack_public_path__ + "db74f7a563ec017311bc7a57573e2497.otf";